"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GOLD_MEDAL_NUMBER = exports.SILVER_MEDAL_NUMBER = exports.BRONZE_MEDAL_NUMBER = void 0;
exports.getMedalNumber = getMedalNumber;
exports.getMedalType = getMedalType;
exports.BRONZE_MEDAL_NUMBER = 1;
exports.SILVER_MEDAL_NUMBER = 2;
exports.GOLD_MEDAL_NUMBER = 3;
function getMedalNumber(type) {
    switch (type) {
        case 'bronze':
            return exports.BRONZE_MEDAL_NUMBER;
        case 'silver':
            return exports.SILVER_MEDAL_NUMBER;
        case 'gold':
            return exports.GOLD_MEDAL_NUMBER;
        default:
            return 0;
    }
}
function getMedalType(number) {
    switch (number) {
        case exports.BRONZE_MEDAL_NUMBER:
            return 'bronze';
        case exports.SILVER_MEDAL_NUMBER:
            return 'silver';
        case exports.GOLD_MEDAL_NUMBER:
            return 'gold';
        default:
            return 'none';
    }
}
//# sourceMappingURL=medal.js.map